module.exports = __webpack_public_path__ + "img/41_16.c1b01503.png";